import React from "react";
import AnimatedIntro from "../intro/Intro";
import AuthOptionsButtons from "./components/AuthOptionsButtons";
import { useStartup } from "./useStartup";
import "./Startup.css";
import Intro from "../intro/Intro";
import { useAuth } from "@/contexts/AuthContext";

export default function Startup() {
  const {
    error,
    signUp,
    isLoading,
    successMessage,
    showCodeInput,
    introCompleted,

    handleOptionSelect,
    handleIntroComplete,
    addOrganization,

    isOnline,
    loadingStates,
  } = useStartup();

  const { userId } = useAuth();

  if (!introCompleted) {
    return <AnimatedIntro onComplete={handleIntroComplete} />;
  }

  return (
    <>
      {!localStorage.getItem("isIntroSeen") && (
        <Intro onComplete={undefined} />
      )}
      {!signUp ? (
        <div>
          <div>
            {error && !showCodeInput && (
              <div className="auth-error-message">{error}</div>
            )}
            {successMessage && !showCodeInput && (
              <div className="auth-success-message">{successMessage}</div>
            )}

            <div>
              {
                <AuthOptionsButtons
                  userId={userId}
                  onOptionSelect={handleOptionSelect}
                  onSubmit={addOrganization}
                  isLoading={isLoading}
                  isOnline={isOnline}
                  loadingStates={loadingStates}
                />
              }
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
